import { TaskType } from './task-type.enum';
import { TaskRelevance } from './task-relevance.enum';
export class Task {
  id: number;
  nameDictionaryKey: string;
  selected: boolean;
  relevance: TaskRelevance;
  done: boolean;
  type: TaskType;
  documentTemplateId: number;
  processingStatus: string;

  constructor(task: any) {
    this.id = task.id;
    this.nameDictionaryKey = task.nameDictionaryKey;
    this.selected = task.selected;
    this.relevance = task.relevance;
    this.done = task.done;
    this.type = task.type;
    this.documentTemplateId = task.documentTemplateId;
    this.processingStatus = task.processingStatus;
  }
}
